/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_All_Rights_ReservedInputs */

const en_footer_all_rights_reserved = /** @type {(inputs: Footer_All_Rights_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All rights reserved.`)
};

const es_footer_all_rights_reserved = /** @type {(inputs: Footer_All_Rights_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los derechos reservados.`)
};

/**
* | output |
* | --- |
* | "All rights reserved." |
*
* @param {Footer_All_Rights_ReservedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const footer_all_rights_reserved = /** @type {((inputs?: Footer_All_Rights_ReservedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_All_Rights_ReservedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_all_rights_reserved(inputs)
	return en_footer_all_rights_reserved(inputs)
});